import '../sass/style.scss';

import 'imports-loader?define=>false!animation.gsap';
import ScrollMagic from 'ScrollMagic';
import MorphSVGPlugin from './lib/MorphSVGPlugin'
import CustomEase from './lib/CustomEase'

import { $, $$ } from './lib/bling';


// load our helper functions
const h = require('./helpers');

const defaults = {
    offset() {
        return  0 - (h.viewportHeight() * 0.25);
    },
    offsetLarge() {
        return  0 - (h.viewportHeight() * 1);
    },
    imageDuration() {
        return  h.viewportHeight() * 0.5;
    },
    imageDurationLarge() {
        return  h.viewportHeight() * 0.75;
    },
    imageDurationFull() {
        return  h.viewportHeight();
    }
}

// create our scroll magic instance
let scroll;

// we need to monitor our screen width in order to rebuid our svgs that are screen width dependent
let windowWidth = h.viewportWidth();

// set a flag to use to throttle callback functions
let resizeInProgress = false;
const resizing = () => {


    if (!resizeInProgress) {
        
        resizeInProgress = true; // throttle this function
        
        setTimeout(function() {
            
            if (detectIE()) {
                setHeightOfSVGContainers();
            }
            
            resizeInProgress = false;

        }, 50);

    }


}


/**
 * adjusts SVGs that display differently based on screen width
 * @return NULL
 * @author Bill McGlone
 */



if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}






   



// the function to set our animations!
const setUpAnimations = () => {

    let scenes = []; // we will add our scens to this container as we create them
    scroll = new ScrollMagic.Controller(); // create our container...
    
    
    /**
     * Animate all the incrementing numbers
     */

    // array of ids containing the numbers to animate
    const animatingNumbers = ['s1_number_1', 's2_number_1', 's2_number_2', 's3_number_1','s3_number_2', 's3_number_3', 's3_number_4'];

    // loop through ids and increment
    animatingNumbers.forEach(function(id) {

        const num = { var: 0 };
        const cd = TweenMax.to(num, 1, {
            var: parseInt($(`#${id}`).getAttribute('data-target')), 
            onUpdate: function () {
                $(`#${id}`).innerHTML = Math.ceil(num.var);
            },
            ease:Circ.easeOut
        });   

        const countdown = new ScrollMagic.Scene({
            triggerElement: `#${id}`,
            offset: defaults.offset()
        }).setTween(cd);
        
        // add it to our scenes holder
        scenes.push(countdown);

    });

   

    /**
     * Animate the intro graphic 
     */

    const introAnimation = new TimelineMax({ repeat: 0, repeatDelay: 2 }); 
    introAnimation   
        .set('#manLeft', { x : '-=120'})
        .set('#manRight', { x : '+=120'})
        .set('#arrowRight', { x : '-145'})
        .set('#arrowLeft', { x : '+145'})
        .set('#MainLargeCloud', {transformOrigin: '50% 100%', y : '+=50'})
        .fromTo('#manLeft', 0.75, { x : '-=120', visibility : 'hidden', opacity : '0' }, { x : '0', visibility : 'visible', opacity : 1, ease:  Power3. easeOut }, 0.1)
        .fromTo('#manRight', 0.75, { x : '+=120', visibility : 'hidden', opacity : '0' }, { x : '0', visibility : 'visible', opacity : 1, ease:  Power3. easeOut }, 0.1)
        .fromTo('#MainLargeCloud', 0.75, { scaleX : 0.01, scaleY : 0.01, visibility : 'hidden', opacity : '0', y : '+=50' }, { scaleX : 1, scaleY : 1, visibility : 'visible', opacity : 1, y : 0, ease:  Power3. easeIn }, 0.45)
        .fromTo('#arrowRight', 0.5, { x : '-145', visibility : 'hidden',}, { x : '0', visibility : 'visible', ease:  Power3. easeIn }, 1.85)
        .fromTo('#arrowLeft', 0.5, { x : '+145', visibility : 'hidden',}, { x : '0', visibility : 'visible', ease:  Power3. easeIn }, 1.85)

    const introAnimationClouds = new TimelineMax({ repeat: 0, repeatDelay: 2 }); 
    introAnimationClouds   
        .fromTo('.cloudFromLeft', 1.5, { visibility : 'hidden', opacity : '0' }, { visibility : 'visible', opacity : 1}, 0.9 )
        .fromTo('.cloudFromLeft', 1, { x : '-=90' }, { x : '0'}, 0.9 )
        .fromTo('.cloudFromLeft1', 1.9, { visibility : 'hidden', opacity : '0' }, { visibility : 'visible', opacity : 1}, 0.5 )
        .fromTo('.cloudFromLeft1', 1, { x : '-=90' }, { x : '0'}, 0.5 )
        .fromTo('.cloudFromRight1', 1.9, { visibility : 'hidden', opacity : '0' }, { visibility : 'visible', opacity : 1}, 0.5 )
        .fromTo('.cloudFromRight1', 1, { x : '+=90' }, { x : '0'}, 0.5 )


    const sceneIntro = new ScrollMagic.Scene({
        triggerElement: '#top_trigger'
    }).setTween(introAnimation, introAnimationClouds);

    // add it to our scenes holder
    scenes.push(sceneIntro);


    /**
     * Scene One
     */

    const s1Animation = new TimelineMax({ repeat: 0, repeatDelay: 0 }); 
    s1Animation  
        .set('#arrowLeftWhite', { x : '-260'}) 
        .set('#arrowRightWhite', { x : '+260'}) 
        .fromTo('#arrowLeftWhite', 3.25, { x : '-260'  }, { x : '0' , ease:  Expo.easeOut }, 0)
        .fromTo('#arrowRightWhite', 3.25, { x : '+260'  }, { x : '0' , ease:  Expo.easeOut }, 0)
        
    const sceneS1 = new ScrollMagic.Scene({
        triggerElement: '#s1_trigger_1'
    }).setTween(s1Animation);

    // add it to our scenes holder
    scenes.push(sceneS1);


     /**
     * Scene Two
     */

    const s2Animation = new TimelineMax({ repeat: 0, repeatDelay: 0 }); 
    s2Animation  
        .set('#cloudTopRight', { x : '-130'}) 
        .set('#cloudBottomRight', { x : '-150'}) 
        .set('#cloudTopLeft', { x : '+260'}) 
        .set('#cloudBottomLeft', { x : '+150'}) 
        .fromTo('#cube', 3.95, { y : '+=435'  }, { y : '0' , ease:   Power2.easeOut }, 0.25)
        .fromTo('#cloudTopRight', 3.25, { x : '-130'  }, { x : '+90' , ease:  Expo.easeOut }, 0)
        .fromTo('#cloudTopLeft', 3.25, { x : '+260'  }, { x : '0' , ease:  Expo.easeOut }, 0)
        .fromTo('#cloudBottomRight', 3.65, { x : '-110'  }, { x : '+180' , ease: Expo.easeOut }, 0.05)
        .fromTo('#cloudBottomLeft', 3.85, { x : '+150'  }, { x : '0' , ease: Expo.easeOut }, 0.05)

    const sceneS2 = new ScrollMagic.Scene({
        triggerElement: '#s2_trigger_1'
    }).setTween(s2Animation);

    // add it to our scenes holder
    scenes.push(sceneS2);
    
     /**
     * Scene Three
     */

    const s3Animation = new TimelineMax({ repeat: 0, repeatDelay: 0 }); 
    s3Animation  
        .set('#cloudsAnalyticalBars', { y : '+90', x : '+30' }) 
        .set('#cloudsAnalyticalGraph', { y : '+110', x : '-30' }) 

        .fromTo('#cloudsAnalyticalCloudR', 2.25, { x : '+180',  visibility: 'hidden'}, { visibility: 'visible', x : '0' , ease: Expo.easeOut }, 0.15)
        .fromTo('#cloudsAnalyticalCloudL', 2.65, { x : '-180',  visibility: 'hidden' }, { visibility: 'visible',  x : '0' , ease: Expo.easeOut }, 0.15)
        // .add('cloudsAnalyticalCloudsUP')
        .to('#cloudsAnalyticalBars', 1, {  y : '0', x : '0' , ease:  Expo.easeOut }, 0.74)
        // .add('cloudsAnalyticalBarsUP')
        .to('#cloudsAnalyticalGraph', 1.3, {  y : '0', x : '0' , ease:  Expo.easeOut }, 0.85)

        .fromTo('#grey', 3.25, {  visibility: 'hidden', opacity : '0'  }, { visibility: 'visible',opacity : '1' , ease:  Expo.easeOut }, 1.8)
        
    const sceneS3 = new ScrollMagic.Scene({
        triggerElement: '#s3_trigger_1'
    }).setTween(s3Animation);

    // add it to our scenes holder
    scenes.push(sceneS3);


     /**. rotatingCircleWithIcons
     * Scene Four
     */
   
    const s4Animation = new TimelineMax({ repeat: 0, repeatDelay: 0 }); 
    s4Animation  
        .fromTo('#lady', 1, { y : '+435', visibility : 'hidden' }, { y : '0', visibility: 'visible', ease: Power2.easeOut }, 0.8)
        
        
    const s4Animation1 = new TimelineMax({ repeat: -1, repeatDelay: 0 }); 
    s4Animation1  
        .set('#rotatingCircleWithIcons, #rotatingIconCube, #rotatingIconPlay, #rotatingIconA, #rotatingIconCloud, #greyDots', { transformOrigin : '50% 50%' }) 
        .fromTo('#rotatingCircleWithIcons', 1, {  rotation : 0 }, { rotation : '+=90', ease:  Expo.easeOut }, 0.8)
        .fromTo('#rotatingIconCube', 1, {  rotation : 0 }, { rotation : '-=90', ease:  Expo.easeOut }, 0.8)
        .fromTo('#rotatingIconPlay', 1, {  rotation : 0 }, { rotation : '-=90', ease:  Expo.easeOut }, 0.8)
        .fromTo('#rotatingIconA', 1, {  rotation : 0 }, { rotation : '-=90', ease:  Expo.easeOut }, 0.8)
        .fromTo('#rotatingIconCloud', 1, {  rotation : 0 }, { rotation : '-=90', ease:  Expo.easeOut }, 0.8)

        .to('#greyDots', 1, { rotation : '-=45', ease:  Expo.easeOut }, 0.8)
        .to('#greyDots', 1, { rotation : '-=45', ease:  Expo.easeOut }, 2.8)
        .to('#greyDots', 1, { rotation : '-=45', ease:  Expo.easeOut }, 4.8)
        .to('#greyDots', 1, { rotation : '-=45', ease:  Expo.easeOut }, 6.8)

        .to('#rotatingCircleWithIcons', 1, { rotation : '+=90', ease:  Expo.easeOut }, 2.8)
        .to('#rotatingIconCube', 1, { rotation : '-=90', ease:  Expo.easeOut }, 2.8)
        .to('#rotatingIconPlay', 1, { rotation : '-=90', ease:  Expo.easeOut }, 2.8)
        .to('#rotatingIconA', 1, { rotation : '-=90', ease:  Expo.easeOut }, 2.8)
        .to('#rotatingIconCloud', 1, { rotation : '-=90', ease:  Expo.easeOut }, 2.8)

        .to('#rotatingCircleWithIcons', 1, { rotation : '+=90', ease:  Expo.easeOut }, 4.8)
        .to('#rotatingIconCube', 1, { rotation : '-=90', ease:  Expo.easeOut }, 4.8)
        .to('#rotatingIconPlay', 1, { rotation : '-=90', ease:  Expo.easeOut }, 4.8)
        .to('#rotatingIconA', 1, { rotation : '-=90', ease:  Expo.easeOut }, 4.8)
        .to('#rotatingIconCloud', 1, { rotation : '-=90', ease:  Expo.easeOut }, 4.8)

        .to('#rotatingCircleWithIcons', 1, { rotation : '+=90', ease:  Expo.easeOut }, 6.8)
        .to('#rotatingIconCube', 1, { rotation : '-=90', ease:  Expo.easeOut }, 6.8)
        .to('#rotatingIconPlay', 1, { rotation : '-=90', ease:  Expo.easeOut }, 6.8)
        .to('#rotatingIconA', 1, { rotation : '-=90', ease:  Expo.easeOut }, 6.8)
        .to('#rotatingIconCloud', 1, { rotation : '-=90', ease:  Expo.easeOut }, 6.8)
        ;

    const sceneS4 = new ScrollMagic.Scene({
        triggerElement: '#s4_trigger_1'
    }).setTween(s4Animation, s4Animation1);




   const s4col1Animation = new TimelineMax({ repeat: -1, repeatDelay: 2.5 }); 
    s4col1Animation
          .fromTo('#handClicking', 0.2, { y : 0}, { y : +10, ease: Power0.easeNone }, 0)
          .fromTo('#innerCircle1', 0.2, { visibility: 'hidden', opacity : 0 }, { opacity : 1, visibility: 'visible', ease: Power0.easeNone }, 0.05)
          .fromTo('#outerCircle', 0.2, { visibility: 'hidden', opacity : 0 }, { opacity : 1, visibility: 'visible', ease: Power0.easeNone }, 0.15)
          .fromTo('#innerCircle1', 0.2, { visibility: 'hidden', opacity : 1 }, { opacity : 0, visibility: 'visible', ease: Power0.easeNone }, 0.5)
          .fromTo('#outerCircle', 0.2, { visibility: 'hidden', opacity : 1 }, { opacity : 0, visibility: 'visible', ease: Power0.easeNone }, 0.6)

    const sceneS4col1 = new ScrollMagic.Scene({
        triggerElement: '#s4_trigger_3'
    }).setTween(s4col1Animation);


  const s4col2Animation = new TimelineMax({ repeat: -1, repeatDelay: 3 }); 
    s4col2Animation
    .fromTo('#light1', 0.2, { visibility: 'hidden', opacity : 0 }, { opacity : 1, visibility: 'visible', ease: Power0.easeNone }, )
    .fromTo('#light2', 0.2, { visibility: 'hidden', opacity : 0 }, { opacity : 1, visibility: 'visible', ease: Power0.easeNone }, )
    .fromTo('#light3', 0.2, { visibility: 'hidden', opacity : 0 }, { opacity : 1, visibility: 'visible', ease: Power0.easeNone }, )
    .fromTo('#light4', 0.2, { visibility: 'hidden', opacity : 0 }, { opacity : 1, visibility: 'visible', ease: Power0.easeNone }, )
    .fromTo('#light5', 0.2, { visibility: 'hidden', opacity : 0 }, { opacity : 1, visibility: 'visible', ease: Power0.easeNone }, )
    

    const sceneS4col2 = new ScrollMagic.Scene({
        triggerElement: '#s4_trigger_4'
    }).setTween(s4col2Animation);


    // add it to our scenes holder
    scenes.push(sceneS4);
    scenes.push(sceneS4col1);
    scenes.push(sceneS4col2);




     /** 
     * Scene Five
     */
    const s5Animation1 = new TimelineMax({ repeat: -1, repeatDelay: 0 }); 
    s5Animation1
        .set('.s5clouds1', { y : '+435' })   
        .set('.s5clouds2', { y : '+135' })       
        .set('.s5clouds3', { y : '+435' }) 
        .fromTo('.s5clouds1', 2.35, { visibility: 'hidden', y: '+435' }, { visibility: 'visible', y: '-200', ease: Power0.easeNone }, 1.5)
        .fromTo('.s5clouds2', 3.35, { visibility: 'hidden', y: '+135' }, {visibility: 'visible', y: '-200', ease: Power0.easeNone }, 0)
        .fromTo('.s5clouds2', 2.35, { visibility: 'hidden', y: '+135' }, {visibility: 'visible', y: '-200', ease: Power0.easeNone }, 2.35)

    const s5Animation2 = new TimelineMax({ repeat: -1, repeatDelay: 0 }); 
    s5Animation2      
        .set('.s5clouds3', { y : '+35', x: '-=60' }) 
        .fromTo('.s5clouds3', 2.35, { visibility: 'hidden', y: '+35' }, {visibility: 'visible', y: '-300', ease: Power0.easeNone }, 2.5)

    const s5Animation3 = new TimelineMax({ repeat: -1, repeatDelay: 0 }); 
    s5Animation3    
        .set('.pack1',  { transformOrigin: '50% 15%' })   
        .set('.pack2', { transformOrigin: '50% 20%' })  
        .set('.pack3', { transformOrigin: '50% 15%' })
        .fromTo('.pack1', 1.65, { rotation: '0'  }, { rotation: '15' , ease: Power0.easeNone }, 0.1)
        .fromTo('.pack1', 1.65, { rotation: '15'  }, { rotation: '0' , ease: Power0.easeNone }, "+=0.1")

    const s5Animation4 = new TimelineMax({ repeat: -1, repeatDelay: 0 }); 
    s5Animation4   
        .fromTo('.pack2', 1.95, { rotation: '0'  }, { rotation: '-10' , ease: Power0.easeNone }, 0.1)
        .fromTo('.pack2', 1.95, { rotation: '-10'  }, { rotation: '0' , ease: Power0.easeNone }, "+=0.1")
        // .fromTo('.pack3', 1.65, { rotation: '0'  }, { rotation: '15' , ease: Power0.easeNone }, 0.1)
        // .fromTo('.pack3', 1.65, { rotation: '15'  }, { rotation: '0' , ease: Power0.easeNone }, "+=0.1")

    const s5Animation5 = new TimelineMax({ repeat: -1, repeatDelay: 0 }); 
    s5Animation5   
        
        .fromTo('.pack3', 1.25, { rotation: '0'  }, { rotation: '-12' , ease: Power0.easeNone }, 0.1)
        .fromTo('.pack3', 1.25, { rotation: '-12'  }, { rotation: '0' , ease: Power0.easeNone }, "+=0.1")

    const sceneS5 = new ScrollMagic.Scene({
        triggerElement: '#s5_trigger_1'
    }).setTween(s5Animation1, s5Animation2, s5Animation3, s5Animation4, s5Animation5);

    // add it to our scenes holder
    scenes.push(sceneS5);


   



    /**
     * Summary Scene
     */
    
    const summaryAnimation = new TimelineMax();
    summaryAnimation.set('#txt1', { attr : { 'width' : 0 } })
    .set('#txt2', { attr : { 'width' : 0 } })
    .set('#txt3', { attr : { 'width' : 0 } })
    .to('#txt1', 0.25, { attr : { 'width' : 69 }, ease: Power2.easeInOut }, 0)
    .to('#txt2', 0.25, { attr : { 'width' : 69 }, ease: Power2.easeInOut }, 0.15)
    .to('#txt3', 0.25, { attr : { 'width' : 48 }, ease: Power2.easeInOut }, 0.3);

    // animate the quote marks (not on a scene as will move constantly)
    
    const animateQuotes = new TimelineMax({repeat: -1});
    animateQuotes.fromTo('#clippedQuotes', 2, { x : 0 }, { x : '-36%', ease: Linear.easeNone }, 0);

    const sceneSummary = new ScrollMagic.Scene({
        triggerElement: '#summary_trigger',
        offset: defaults.offset()
    }).setTween(summaryAnimation);

    // add it to our scenes holder
    scenes.push(sceneSummary);


const sceneSections = $$('.scene__numbered');

  sceneSections.forEach(e => {
    const headerScene = new ScrollMagic.Scene({
      triggerElement: e,
      triggerHook: 0.8
    }).setClassToggle(e, 'visible');

    scenes.push(headerScene);
  });



    // add our scenes to our scroll magic container
    scroll.addScene(scenes);



}


document.addEventListener("DOMContentLoaded", function(event) { 
    
    if (detectIE()) {
        document.getElementsByTagName("body")[0].classList.add('ie');
        setHeightOfSVGContainers();
    }

    //prepareSVGs();
    
    setUpAnimations();

    window.on('resize', resizing);
    
});


function setHeightOfSVGContainers() {
    
    const containerWidth = h.getElementWidth('top_trigger');

    // intro image is 0.6237 height of container width
    const introImageHeight = containerWidth * 0.5921;
    document.getElementById('intro_graphic_container').style.height = introImageHeight +'px';

}


function detectIE() {
  
  var ua = window.navigator.userAgent;

  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  // other browser
  return false;
}


// WEBPACK FOOTER //
// ./app/js/main.js